import PropTypes from 'prop-types';

import { v4 as uuidv4 } from 'uuid';

import {
  useColorModeValue,
  Box,
  Checkbox,
  Flex,
  Tag,
  Text,
  Tooltip,
  TagLeftIcon,
  TagLabel,
  IconButton,
} from '@chakra-ui/react';
import { FaCheckCircle, FaGlobe, FaLock, FaPen } from 'react-icons/fa';

import { ChevronRightIcon } from '@chakra-ui/icons';

function CourseToAdd({
  data,
  checkValue,
  handleCheckboxChange,
  handlePreview,
}) {
  return (
    <Box mb={2} borderWidth="1px" borderRadius="md">
      <Box w="100%" p={2} bg={useColorModeValue('#f7f7f7', 'gray.800')}>
        <Flex alignItems="center" mx={3} gap={3}>
          <Checkbox
            isChecked={checkValue}
            onChange={() => handleCheckboxChange(data.id, !checkValue)}
          />
          <Flex direction="column" flex="1" gap={2}>
            <Text fontSize="md" fontWeight="semibold">
              {data?.name}
            </Text>
            <Flex gap={2}>
              {data?.tags &&
                Array.isArray(JSON.parse(data?.tags)) &&
                JSON.parse(data.tags).map((tag) => (
                  <Tag key={uuidv4()} p={2} color="teal" size="sm">
                    {tag}
                  </Tag>
                ))}
            </Flex>
            <Flex direction="column" gap={3} align="start">
              <Text fontSize="xs" fontWeight={500}>
                Category: {data?.category?.name || 'N/A'}
              </Text>
              <Flex align="center" wrap="wrap" gap={2}>
                <Tooltip label={data?.isPublished ? 'Published' : 'Draft'}>
                  <Tag
                    size="sm"
                    colorScheme={data?.isPublished ? 'green' : 'purple'}
                    variant="solid"
                  >
                    <TagLeftIcon
                      as={data?.isPublished ? FaCheckCircle : FaPen}
                    />
                    <TagLabel>
                      {data?.isPublished ? 'Published' : 'Draft'}
                    </TagLabel>
                  </Tag>
                </Tooltip>

                <Tooltip
                  label={
                    data?.isPrivate
                      ? 'This can only be accessed via specific access list or class'
                      : 'This can be accessed by all trainees'
                  }
                >
                  <Tag
                    size="sm"
                    colorScheme={data?.isPrivate ? 'red' : 'green'}
                    variant="solid"
                  >
                    <TagLeftIcon as={data?.isPrivate ? FaLock : FaGlobe} />
                    <TagLabel>
                      {data?.isPrivate ? 'Private' : 'Global'}
                    </TagLabel>
                  </Tag>
                </Tooltip>
              </Flex>
            </Flex>
          </Flex>

          <Tooltip label="Preview this course">
            <IconButton
              onClick={() => handlePreview(data?.id)}
              colorScheme="blue"
              variant="ghost"
              aria-label="Preview course"
              fontSize="40px"
              icon={<ChevronRightIcon />}
            />
          </Tooltip>
        </Flex>
      </Box>
    </Box>
  );
}

CourseToAdd.defaultProps = {
  checkValue: false,
};

CourseToAdd.propTypes = {
  data: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  handlePreview: PropTypes.func.isRequired,
  checkValue: PropTypes.bool,
};

export default CourseToAdd;
